import {Component} from "react";
import * as React from "react";

import {WorkloadStats} from "../models/WorkloadAnalytics";
import * as _ from "lodash";
import Table, {TableColumn} from "./Table";
import {TableRowProps} from "./TableRow";

interface WorkloadPerformanceListProps
{
    workloadStats: WorkloadStats[];
    onClick(workloadName: string): void;
}

interface WorkloadPerformanceListState
{
    rows?: any[];
}

export default class WorkloadPerformanceList extends Component<WorkloadPerformanceListProps,WorkloadPerformanceListState>
{
    private static columns: TableColumn[] = [
        {
            title: "Name",
            propertyPath: "workloadName",
            enableSort: true,
            flex: 1
        },
        {
            title: "Failed",
            extraDetail: "With status failed",
            propertyPath: "failedTotal",
            enableSort: true,
            flex: 1
        },
        {
            title: "Completed",
            extraDetail: "With status completed",
            propertyPath: "completedTotal",
            enableSort: true,
            flex: 1,
        },
        {
            title: "Total",
            extraDetail: "With any status",
            propertyPath: "allStatusTotal",
            enableSort: true,
            flex:1
        },
        {
            title: "Average Run Time",
            extraDetail: "With status completed",
            propertyPath: "completedAverageRunTime",
            type: "durationSeconds",
            enableSort: true,
            flex: 1
        },
        {
            title: "Completion Rate",
            extraDetail: "% with status completed",
            propertyPath: "completedPercentage",
            enableSort: true,
            flex:1
        }
    ];

    constructor(props: Readonly<WorkloadPerformanceListProps>) {
        super(props);

        this.state = {
            rows: undefined
        }
    }

    public componentDidMount() {
        if(this.props.workloadStats)
        {
            this.setRows();
        }
    }


    componentDidUpdate(prevProps: Readonly<WorkloadPerformanceListProps>, prevState: Readonly<WorkloadPerformanceListState>, snapshot?: any): void {
        if(this.props.workloadStats !== prevProps.workloadStats)
        {
            this.setRows();
        }
    }

    private setRows()
    {
        if(this.props.workloadStats)
        {
            const groupedWorkloadStats: any = _.groupBy(this.props.workloadStats,(wls: WorkloadStats) => wls.workloadName);
            const rows = _.keys(groupedWorkloadStats).map((workloadName: string) => {

                const workloadStats: WorkloadStats[] = groupedWorkloadStats[workloadName];
                
                const row: any = {
                    workloadName: workloadName,
                    allStatusTotal: _.sumBy(workloadStats,(wls) => wls.allStatusCount),
                    completedTotal: _.sumBy(workloadStats,(wls) => wls.completedCount),
                    failedTotal: _.sumBy(workloadStats,(wls) => wls.failedCount),
                    completedAverageRunTime: _.meanBy(workloadStats,(wls: WorkloadStats) => wls.completedAverageRunTime)
                }
                
                row.completedPercentage = row.allStatusTotal > 0 ? ((row.completedTotal / row.allStatusTotal) * 100).toFixed(2) : (0).toFixed(2);

                return row;
            });


            this.setState({
                rows
            });
        }
    }
    
    private rowPropsForItem = (item: WorkloadStats): TableRowProps => {
        
        return {
            onClick: () => this.props.onClick(item.workloadName)
        }
    }

    public render() {

        if(this.state.rows === undefined)
        {
            return null;
        }
        
        return <Table className={"cdb-table--enable-hover"} title="Workload Performance" items={this.state.rows} rowPropsForItem={this.rowPropsForItem} columns={WorkloadPerformanceList.columns} enableSort={true}/>
    }
}